/**
 * Vacancy Spend API — AppFolio GL labor/materials by vacancy window.
 */
import { fetchWithAuth } from './api';

const API_URL = '/api/vacancy-spend';

export const fetchVacancySpend = async (params = {}) => {
  const query = new URLSearchParams();
  if (params.propertyId) {
    query.set('property_id', String(params.propertyId));
  }
  const qs = query.toString();
  const response = await fetchWithAuth(qs ? `${API_URL}?${qs}` : API_URL, {
    signal: params.signal,
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error || body.detail || 'Failed to load vacancy spend');
  }
  return response.json();
};
